import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { IPhysiologicalDataDetails, PhysiologicalDataDetails } from '../PhysiologicalData';
import { PhysiologicalDataApi } from '../../../apis/PhysiologicalDataApi/PhysiologicalDataApi';

export function usePostPhysiologicalData() {
    const queryClient = useQueryClient();

    return useMutation<IPhysiologicalDataDetails, AppMedError, IPhysiologicalDataDetails>({
        mutationKey: [QueryKeys.physiologicalDataDetails, 'create'],
        mutationFn: async (variables: IPhysiologicalDataDetails) => {
            const result = await PhysiologicalDataApi.postPhysiological(variables);
            return new PhysiologicalDataDetails(result);
        },
        onSuccess: async (data: IPhysiologicalDataDetails) => {
            queryClient.setQueryData<IPhysiologicalDataDetails[]>([QueryKeys.physiologicalDataDetails], (prev) => {
                return prev ? [...prev, data] : [data];
            });
        },
    });
}
